export default () => ({
    following: [],
    followers: [],
    
    followingCount: 0,
    followersCount: 0,
});